import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import MLSAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/MLSAppResource";
import FileAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/FileAppResource";

class PartnerMlsMappingAppResource extends AppResource {
    /**
     * @returns {string}
     */
    appResourceType() {
        return 'partner_mls_mapping';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'partners/mls/mappings';
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'partnerMls',
            'mlsUuid',
            'partnerMlsName',
            'partnerText',
            'partnerImageUuid',
            'leftButtonText',
            'leftButtonUrl',
            'rightButtonText',
            'rightButtonUrl',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            mls: MLSAppResource,
            partnerImage: FileAppResource,
        };
    }

    relationForeignKeys() {
        return {
            mls: 'mls_uuid',
            partnerImage: 'partner_image_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            partnerMls: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            partnerMlsName: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            mlsUuid: {
                type: 'string'
            },
            partnerImageUuid: {
                type: 'string'
            },
            partnerText: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            leftButtonText: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            leftButtonUrl: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            rightButtonText: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            rightButtonUrl: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
        };
    }

}

export default PartnerMlsMappingAppResource;
